// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wXilG","root__whitelabel":"styles_root__whitelabel__Yy0qt","headingContainer":"styles_headingContainer__Au_Kr"};